<template>
  <div class="hello">
      <div class="container margin_60_35">
          <div class="row">
          <profileNav/>
          <MyAccount/>
          </div>
      </div>
  </div>  
</template>

<script>
import MyAccount from "@/components/MyAccount.vue";
import profileNav from './profile_nav'
export default {
  name: 'Userprofile',
  components:{
    MyAccount,
    profileNav
  },
}
</script>
<style>
 
</style>
